import styled from "styled-components";
import {Button, Input, Select, Table} from "antd";
export const SelectField = styled(Select)`
    width: 75%;
    margin-bottom: 20px;
`;

export const RightButton = styled(Button)`
    float: right;
`;
export const SearchInput = styled(Input.Search)`
    width: 320px;
    margin-top: 3px;
`;

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
    @media screen and (max-width: 768px) {
        .ant-table table td {
            display: ${props => props.display};
            grid-template-columns: 1fr 1fr;

            justify-content: center;
            align-items: center;
        }
        .ant-table-cell {
            flex-direction: column;
        }
        .ant-table table th {
            display: none;
        }
        .ant-table table td::before {
            font-weight: bold;
            padding-right: 5px;
        }
        .ant-table table tr td {
            padding: 6px 16px !important;
        }
        .ant-table table tr td:first-child {
            padding-top: 16px !important;
        }
        .ant-table table tr td:last-child {
            padding-bottom: 16px !important;
            max-width: 300px;
        }
        ${props =>
            props.dataTitles.map(
                (title, index) =>
                    `.ant-table table td:nth-child(${index + 1})::before {
                content: "${title}: ";
            }`
            )}
        .ant-table table tr {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: block;
            -webkit-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            -moz-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
    }
`;
